import { axios } from '@/lib/axios';

export interface AcknowledgeParentConnectPayload {
  session_id: string;
  start_time: number;
}

export const acknowledgeParentConnect = async (
  payload: AcknowledgeParentConnectPayload
) => {
  const data: {
    status?: string;
    responseBody?: { session_id: string; parent_acknowledged: boolean };
  } = await axios.post(
    '/user/v1/trainer-slots/parent-connect/request/acknowledge',
    payload
  );
  if (
    data.status !== 'SUCCESS' ||
    data.responseBody?.session_id !== payload.session_id ||
    data.responseBody.parent_acknowledged !== true
  ) {
    throw new Error('Unable to acknowledge Parent Connect');
  }
  return data.responseBody;
};
